import axios, { Method } from "axios";

type IBody = object | string | null;

const isSuccessCode = (statusCode: number) => {
  return statusCode >= 200 && statusCode < 300;
};

export class ApiService {
  private headers: any = {
    "Content-Type": "application/json; charset=utf-8",
  };
  private baseUrl = "";

  public setBaseUrl = (url: string) => {
    this.baseUrl = url;
  };

  public setHeaders(headers: object) {
    //console.log('request header =>', headers)
    this.headers = headers;
  }

  public getHeaders(): object {
    return this.headers;
  }

  public async start(method: string, url: string, body: IBody | any, timeout: number = 60000) {
    return new Promise((resolve, reject) => {
      // console.log(this.headers)

      // @ts-ignore-start
      axios({
        method: method as Method,
        baseURL: this.baseUrl,
        url,
        headers: this.headers,
        data: body,
        timeout: 30000,
      })
        .then((response: any) => {
          if (isSuccessCode(response.status)) {
            return resolve(response.data);
          }
          return reject({
            error: { message: "Teknik hata", ...response.data },
          });
        })
        .catch((error: any) => {
          return reject(error);
        });
    });
  }
}
